export const normalizeText = (value) => (value ?? '').toString().toLowerCase().trim();
export const normalizeRank = (rank) => normalizeText(rank);
